import React from 'react';
import ThemeSettingContent from 'components/admin/manage/themeSetting/ThemeSettingContent';

export const ThemeSettingPage: React.FC = () => {
  return <ThemeSettingContent />;
};
